import React from 'react';
import PropTypes from 'prop-types';
import Cookies from 'js-cookie';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Link } from 'react-router';
import {
  getCalendarLocations,
  fetchCalendarStaticText,
  getCalendarEvents,
  calendarEventsKey,
  getUser,
} from '../../actions.js';
import { confirmAlert, setAlert, errorAlert } from '../../../ui/src/actions.js';
import { Spinner } from '../../../ui/src/component/spinner';
import { CsmArticleContent } from '../../../ui/src/component/csmArticle';
import { Icon } from '../../../ui/src/component/icon';
import { nl2p, getProp } from '../../../ui/src/utilities';
import moment from 'moment';
import { Popup } from '../../component/popup/';
import cx from 'classnames';
import { Helmet } from 'react-helmet';
import Api from '../../../ui/src/api.js';
import Calendar from '../../component/Calendar';
import kecko from '../../../assets/kecko.png';

export const getLocation = (locationId, locations) => {
  let location = null;
  if (locationId === 'all') {
    location = {
      _id: 'all',
      name: 'Východ',
      order: 1,
    };
  } else {
    for (let loc of locations) {
      if (loc._id === locationId) {
        location = loc;
        break;
      }
    }
  }
  return location;
};

class CalendarEvents extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      locationsPopupOpened: false,
      expanded: null,
      isCallendarOpened: false,
    };

    this.handleToggleCalendar = this.handleToggleCalendar.bind(this);
    this.handleClickCalendar = this.handleClickCalendar.bind(this);
    this.getLocationName = this.getLocationName.bind(this);
  }

  componentDidMount() {
    CalendarEvents.init(this.props.dispatch, this.props.params).catch(() => { });
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.params.location !== this.props.params.location ||
      nextProps.params.date !== this.props.params.date
    ) {
      const date = CalendarEvents.getDate(nextProps.params);
      nextProps.dispatch(getCalendarEvents(nextProps.params.location, date));
    }
  }

  static init(dispatch, params) {
    // ak dostaneme datum z url, super, ak nie, berieme dnesok
    const date = CalendarEvents.getDate(params);
    return Promise.all([
      dispatch(getCalendarLocations()),
      dispatch(getCalendarEvents(params.location, date)),
      dispatch(fetchCalendarStaticText()),
    ]);
  }

  handleClickCalendar(e) {
    this.setState({
      isCallendarOpened: false,
    });
    this.props.dispatch(
      push(
        `/calendar/${this.props.params.location}/${moment(e).format(
          'YYYY-MM-DD',
        )}`,
      ),
    );
  }

  handleToggleCalendar() {
    this.setState({
      isCallendarOpened: !this.state.isCallendarOpened,
    });
  }

  onClickLocationPopupItem(item) {
    this.props.dispatch(
      push(
        `/calendar/${item._id}/${CalendarEvents.getDate(
          this.props.params,
        ).format('YYYY-MM-DD')}`,
      ),
    );
    this.setState({ locationsPopupOpened: false });
  }

  static getDate(params) {
    let date = moment();
    if (params.date) {
      date = moment(params.date);
      if (!date.isValid()) {
        date = moment();
      }
    }
    return date;
  }

  onClickDelete(id) {
    let options = {
      onConfirm: (input = '') => {
        Api.delete(`/calendar/events/${id}?password=${input}`)
          .then(res => {
            const date = CalendarEvents.getDate(this.props.params);
            this.props.dispatch(
              getCalendarEvents(this.props.params.location, date),
            );
            this.props.dispatch(setAlert(null));
          })
          .catch(err => {
            console.error(err);
            this.props.dispatch(errorAlert('Udalosť sa nepodarilo odstrániť'));
          });
      },
    };
    const token = Cookies.get('token');
    if (!token) {
      options.type = 'input';
      options.text = 'Heslo pre úpravu';
      options.inputPlaceholder = '';
    }
    Promise.all([
      token
        ? this.props.dispatch(getUser()).then(() => {
          if (
            getProp(this.props, 'user.scopes', []).filter(
              scope => scope === 'admin',
            ).length !== 1
          ) {
            options.type = 'input';
            options.text = 'Heslo pre úpravu';
            options.inputPlaceholder = '';
          }
        })
        : null,
    ]).then(res => {
      this.props.dispatch(confirmAlert('Naozaj odstrániť?', options));
    });
  }

  getLocationName(id) {
    let locationName = null;
    this.props.locations.some(location => {
      if (location._id === id) {
        locationName = location.name;
        return true;
      }
      return false;
    });
    return locationName;
  }

  renderEvent(event, idx) {
    const maxLength = 100;
    const descrIsLong = event.description.length > maxLength;
    const isExpanded = this.state.expanded === idx;
    const isExpandable = event.dates.length > 1 || event.url || descrIsLong;
    return (
      <div
        className={cx('calendar-event', {
          clickable: isExpandable,
          active: isExpanded,
        })}
        onClick={() => {
          this.setState({ expanded: isExpanded ? null : idx });
        }}
      >
        <div className="time-col bg-alt-light controls-enabled">
          <div className="time">
            {moment(event.date_from).format('H:mm')} -{' '}
            {moment(event.date_to).format('H:mm')}
            {this.props.params.location === 'all' ? (
              <div className="event-perex-location">
                {this.getLocationName(event.location)}
              </div>
            ) : null}
          </div>
          <div className="event-controls">
            <Link
              to={`/calendar/edit/${event._id}`}
              onClick={ev => ev.stopPropagation()}
              className="btn btn-default"
            >
              Upraviť
            </Link>
            <a
              href=""
              onClick={ev => {
                ev.preventDefault();
                ev.stopPropagation();
                this.onClickDelete(event._id);
              }}
              className="btn btn-danger"
            >
              Zmazať
            </a>
          </div>
        </div>
        <div className="event-body">
          <h2>{event.title}</h2>
          <div
            className="event-body-descr"
            dangerouslySetInnerHTML={{
              __html: nl2p(
                isExpanded
                  ? event.description
                  : descrIsLong
                    ? `${event.description.substring(0, maxLength)}...`
                    : event.description,
              ),
            }}
          />
          {isExpandable ? (
            <div className="load-more-btn">
              <Icon className="load-more" name="chevron-circle-right" />
              <div className="sub">Viac</div>
              <div className="sub sub-active">Menej</div>
            </div>
          ) : null}
          {isExpanded && (
            <div>
              {event.dates.length > 1 && (
                <div>
                  <div>
                    <strong>Všetky termíny konania:</strong>
                  </div>
                  {event.dates.map((date, idx) => {
                    return (
                      <div key={idx}>
                        {moment(date.from).format('DD.MM.YYYY HH:mm')} -{' '}
                        {moment(date.to).format('DD.MM.YYYY HH:mm')}
                      </div>
                    );
                  })}
                </div>
              )}
              {event.url && (
                <div className="text-right" style={{ marginTop: '10px' }}>
                  <a
                    href={
                      event.url.match(/(^https?:\/\/)/)
                        ? event.url
                        : `http://${event.url}`
                    }
                    onClick={ev => ev.stopPropagation()}
                    target="_blank"
                    className="btn btn-primary btn-link"
                  >
                    Stránka podujatia <Icon name="chevron-circle-right" />
                  </a>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }

  renderEvents(events) {
    if (events.length > 0) {
      return (
        <div>
          {events.map((item, idx) => {
            return <div key={idx}>{this.renderEvent(item, idx)}</div>;
          })}
        </div>
      );
    } else if (this.props.eventsFetching) {
      return <Spinner show={true} />;
    } else {
      return (
        <div
          className="h3 text-center text-muted"
          style={{ marginTop: '70px' }}
        >
          Pre tento deň nie sú naplánované žiadne podujatia
        </div>
      );
    }
  }

  getLocationsList() {
    const locations = getProp(this.props, 'locations', []).map(item => {
      return (
        <a
          onClick={(e) =>{ e.preventDefault(); this.onClickLocationPopupItem(item) }}
          href=""
        >
          {item.name}
        </a>
      );
    });
    const allLocations = {
      _id: 'all',
      name: 'Východ',
      order: 1,
    };
    locations.unshift(
      <a
        onClick={(e) => { e.preventDefault();this.onClickLocationPopupItem(allLocations) }}
        href=""
      >
        {allLocations.name}
      </a>,
    );
    return locations;
  }

  renderDetail(location) {
    const today = moment();
    const date = CalendarEvents.getDate(this.props.params);
    const datePrev = moment(date).subtract(1, 'day');
    const dateNext = moment(date).add(1, 'day');

    return (
      <div>
        <Helmet>
          <title>{`Kalendár - ${location.name}`}</title>
          <meta
            property="og:description"
            content={`Kalendár udalostí pre ${location.name} ku dňu ${date.format(
              'DD.MM.YYYY',
            )}`}
          />
          <meta property="og:image" content={kecko} />
        </Helmet>

        <div className="bg-alt-light article-header">
          <div className="container">
            <div className="article-header-title">
              <h1>
                Kalendár <span className="text-primary">{location.name}</span>{' '}
                <span style={{ position: 'relative', display: 'inline-block' }}>
                  <button
                    className="btn btn-primary btn-xs text-uppercase popup-trigger"
                    onClick={() =>
                      this.setState({
                        locationsPopupOpened: !this.state.locationsPopupOpened,
                      })
                    }
                  >
                    zmeniť
                  </button>
                  &nbsp;
                  <Link
                    to={`/calendar/add/${location._id}`}
                    className="btn btn-primary btn-xs text-uppercase"
                  >
                    pridať udalosť
                  </Link>
                  <span className="popup-container">
                    <Popup
                      eventTypes="click"
                      opened={this.state.locationsPopupOpened}
                      items={this.getLocationsList()}
                      handleClickOutside={() =>
                        this.setState({ locationsPopupOpened: false })
                      }
                      outsideClickIgnoreClass={'popup-trigger'}
                    />
                  </span>
                </span>
              </h1>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="section">
            <div className="row">
              <div
                className="col-sm-12 col-md-8"
                style={{ marginBottom: '70px' }}
              >
                <div className="clearfix calendar-controls">
                  <div className="text-center head pull-left">
                    <span className="text-capitalize">
                      {date.format('dddd')}
                    </span>, {date.format('LL')}
                  </div>
                  <div
                    className="pull-right"
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <span
                      onClick={this.handleToggleCalendar}
                      className="small-calendar-span"
                    >
                      <Icon name="calendar-today" /> Kalendár
                    </span>
                    <div className="btn-group">
                      <Link
                        className="btn btn-link btn-prev"
                        to={`/calendar/${location._id}/${datePrev.format(
                          'YYYY-MM-DD',
                        )}`}
                      >
                        <Icon name="chevron-circle-right" /> Predošlý deň
                      </Link>
                      <Link
                        className="btn btn-link btn-today"
                        to={`/calendar/${location._id}/${today.format(
                          'YYYY-MM-DD',
                        )}`}
                      >
                        Dnes
                      </Link>
                      <Link
                        className="btn btn-link"
                        to={`/calendar/${location._id}/${dateNext.format(
                          'YYYY-MM-DD',
                        )}`}
                      >
                        Ďalší deň <Icon name="chevron-circle-right" />
                      </Link>
                    </div>
                  </div>
                </div>
                {this.state.isCallendarOpened && (
                  <Calendar
                    date={this.props.params.date}
                    onClick={this.handleClickCalendar}
                  />
                )}
                {this.renderEvents(this.props.events)}
              </div>
              <div
                className="col-sm-12 col-md-4"
                style={{ paddingLeft: '15px' }}
              >
                <div className="callendar-small">
                  <Calendar
                    date={this.props.params.date}
                    onClick={this.handleClickCalendar}
                  />
                </div>
                {this.props.calendarStaticText && (
                  <div>
                    {this.props.calendarStaticText.name && (
                      <h2 style={{ marginTop: 0 }}>
                        {this.props.calendarStaticText.name}
                      </h2>
                    )}
                    <CsmArticleContent
                      content={this.props.calendarStaticText}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    let location = null;
    location = getLocation(this.props.params.location, this.props.locations);

    if (location) {
      return this.renderDetail(location);
    }

    return <Spinner show={true} />;
  }
}

CalendarEvents.fetchData = ({ store, renderProps: { params } }) => {
  return CalendarEvents.init(store.dispatch, params);
};

CalendarEvents.propTypes = {
  dispatch: PropTypes.func.isRequired,
  locations: PropTypes.array.isRequired,
  params: PropTypes.object.isRequired,
  calendarStaticText: PropTypes.object,
  events: PropTypes.array.isRequired,
  eventsFetching: PropTypes.bool.isRequired,
};

const getEvents = (eventsByKey, locationId, date) => {
  const key = calendarEventsKey(locationId, date.format('YYYY-MM-DD'));
  if (key in eventsByKey) {
    return eventsByKey[key];
  }
  return [];
};

export default connect((state, props) => {
  return {
    locations: state.calendar.locations,
    events: getEvents(
      state.calendar.events.byKey,
      props.params.location,
      CalendarEvents.getDate(props.params),
    ),
    eventsFetching: state.calendar.events.isFetching,
    calendarStaticText: state.calendarStaticText.data.content,
    user: state.loggedUser.user,
  };
})(CalendarEvents);



// WEBPACK FOOTER //
// ./src/app/container/calendar/calendar-events.js